import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LOOutcomeModalCst from "@components/LOOutcomeModalCst";
import CourseWizard from "../Course/CourseWizard";
import { useSubmitCourseV2 } from "../Course/hooks/useSubmitCourseV2";
import { useSaveDraft } from "../hooks/useSaveDraft";
import { usePromoteDraft } from "../hooks/usePromoteDraft";
import {
  DraftErrorInfo,
  extractPromoteError,
} from "../hooks/parsePromoteErrors";
import DraftPromoteErrorDialog from "../components/DraftPromoteErrorDialog";
import { flattenSelectedLOItems } from "../utils/loStructure";
import { CourseWizardData, EMPTY_COURSE_DATA } from "../Course/types";

const AddCourse: React.FC = () => {
  // const { t: tOutcome } = useTranslation("lo-outcome-modal");
  const navigate = useNavigate();
  const { id: corporateId = "" } = useParams();
  const catalogUrl = `/v2/corporate/${corporateId}/detail/catalog`;

  const { submit: submitCourse } = useSubmitCourseV2({
    corporateId,
  });
  const { saveDraft, isSavingDraft } = useSaveDraft({
    corporateId,
    type: "course",
  });
  const { promoteDraft } = usePromoteDraft({ corporateId });

  const [successOpen, setSuccessOpen] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [promoteError, setPromoteError] = useState<DraftErrorInfo | null>(null);

  const hasDraftChildren = (data: CourseWizardData) =>
    flattenSelectedLOItems(data.selected_activities).some(
      (activity) => activity.entity?.is_draft,
    );

  const handleComplete = async (data: CourseWizardData) => {
    setIsPublishing(true);
    try {
      if (hasDraftChildren(data)) {
        const courseDraft = await saveDraft(data);
        try {
          await promoteDraft(courseDraft.id);
        } catch (err) {
          setPromoteError(extractPromoteError(err));
          throw err;
        }
      } else {
        await submitCourse(data);
      }
      setSuccessOpen(true);
    } finally {
      setIsPublishing(false);
    }
  };

  const handleSaveDraft = async (data: CourseWizardData) => {
    try {
      await saveDraft(data);
      navigate(`${catalogUrl}?tab=all`);
    } catch (error) {
      console.error("[wizard-course] saveDraft failed", error);
      throw error;
    }
  };

  return (
    <>
      <CourseWizard
        initialData={EMPTY_COURSE_DATA}
        onComplete={handleComplete}
        onSaveDraft={handleSaveDraft}
        isSavingDraft={isSavingDraft}
        isSubmitting={isPublishing}
      />
      <LOOutcomeModalCst
        open={successOpen}
        entityType="course"
        mode="add"
        // associationOptions={[
        //   {
        //     key: "path",
        //     title: tOutcome("options.path.title"),
        //     description: tOutcome("options.path.description"),
        //   },
        // ]}
        // onAssociate={() => {
        //   navigate(`${catalogUrl}?tab=paths`);
        // }}
        onDismiss={() => navigate(catalogUrl)}
      />
      <DraftPromoteErrorDialog
        error={promoteError}
        onClose={() => setPromoteError(null)}
      />
    </>
  );
};

export default AddCourse;
